import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Inject a preconnect hint for the backend host BEFORE React mounts so the
// browser can finish DNS + TLS while the JS bundle is still parsing.
// Saves ~100-200ms on the first API call. Uses the runtime env var so it
// works in preview AND production.
(() => {
  const url = process.env.REACT_APP_BACKEND_URL;
  if (!url || typeof document === "undefined") return;
  try {
    const origin = new URL(url).origin;
    if (document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;
    const pre = document.createElement("link");
    pre.rel = "preconnect";
    pre.href = origin;
    pre.crossOrigin = "";
    document.head.appendChild(pre);
    const dns = document.createElement("link");
    dns.rel = "dns-prefetch";
    dns.href = origin;
    document.head.appendChild(dns);
  } catch (e) { /* ignore malformed env */ }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
